<p *ngIf="!orcamentos?.length" class="vazio">Nenhum orçamento encontrado.</p>

<div *ngFor="let o of orcamentos" class="orc">
  <div class="orc-topo">
    <div>
      <div class="orc-tit">Orçamento #{{ o.nr }}
        <span class="sub">{{ o.nrAtendimento ? 'Atend. #' + o.nrAtendimento : '(sem atend.)' }}</span>
      </div>
      <div class="orc-meta">
        <span>{{ o.data }}</span>
        <span>{{ o.medico }}</span>
        <span>{{ o.procedimentos.length }} proc.</span>
        <ng-container *ngIf="o.pendentes > 0">
          <span class="pill-exec">{{ o.executados }}/{{ o.procedimentos.length }} exec.</span>
          <span class="pill-pend">{{ o.pendentes }} pendente(s)</span>
        </ng-container>
        <span>{{ o.status }}</span>
      </div>
    </div>
    <div class="orc-valores">
      <ng-container *ngIf="o.valoresDiferem; else unico">
        <div><span class="rotulo">Particular</span><s>{{ o.vlVista | brl }}</s></div>
        <div><span class="rotulo">Cartão SiM</span><b>{{ o.vlCartao | brl }}</b></div>
      </ng-container>
      <ng-template #unico><div><span class="rotulo">Valor</span><b>{{ o.vlVista | brl }}</b></div></ng-template>
    </div>
    <button type="button" class="seta" [class.aberta]="abertos.has(o.nr)" (click)="alternar(o.nr)"
            [attr.aria-expanded]="abertos.has(o.nr)" [attr.aria-label]="abertos.has(o.nr) ? 'Recolher procedimentos' : 'Ver procedimentos'">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" width="16" height="16" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
      </svg>
    </button>
  </div>
  <div *ngIf="abertos.has(o.nr)" class="orc-corpo">
    <table>
      <tr *ngFor="let p of o.procedimentos">
        <td class="marca" [class.exec]="p.executado" [title]="p.executado ? 'Executado' : 'Pendente'">{{ p.executado ? '✔' : '○' }}</td>
        <td>{{ p.dsProcedimento }}</td>
        <td class="num">{{ p.qtProcedimento }}</td>
        <td class="num">{{ p.vlVista | brl }}</td>
        <td *ngIf="o.valoresDiferem" class="num cartao">{{ p.vlCartao | brl }}</td>
      </tr>
    </table>
  </div>
</div>
